export default __webpack_public_path__ + "static/media/Facemask of the Bloodhunter.bff26bcd.jpg";